import { cn } from "ui2";

type ProfileSectionProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export const ProfileSection = ({ title, children, className }: ProfileSectionProps): React.JSX.Element => (
  <section>
    <h2 className="tw:m-0 tw:mb-2 tw:text-sm tw:font-denim tw:font-medium tw:text-midnight">{title}</h2>
    <div className={cn("tw:overflow-hidden tw:rounded-xs tw:border tw:border-stroke tw:bg-white", className)}>
      {children}
    </div>
  </section>
);

type ProfileRowProps = {
  label: React.ReactNode;
  note?: string;
  value: React.ReactNode;
  caption?: string | null;
  trailing?: React.ReactNode;
};

export const ProfileRow = ({ label, note, value, caption, trailing }: ProfileRowProps): React.JSX.Element => (
  <div className="tw:border-b tw:border-stroke tw:px-4 tw:py-3 tw:last:border-b-0">
    <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
      <div className="tw:min-w-0 tw:flex-1 tw:text-sm tw:text-midnight/75">{label}</div>
      <div className="tw:flex tw:shrink-0 tw:items-center tw:gap-2">
        <div className="tw:text-right">
          <div className="tw:text-sm tw:font-medium tw:tabular-nums tw:text-midnight">{value}</div>
          {caption && <div className="tw:mt-0.5 tw:text-xs tw:text-midnight/50">{caption}</div>}
        </div>
        {trailing}
      </div>
    </div>
    {note && (
      <div className="tw:mt-1.5 tw:max-w-prose tw:text-xs tw:leading-relaxed tw:text-midnight/50">{note}</div>
    )}
  </div>
);
